import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Button from '../../../../../../../components/Button'
import Field from '../../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../../helpers/numbers'

import { selectedTikTokAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { BUDGET_DAILY, BUDGET_LIFETIME, BUDGET_OPTION } from '../../../../../../Multiplatform/fields'

import useStepFormStyles from '../../../../../../../styles/common/stepForms'
import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [BUDGET_LIFETIME, BUDGET_DAILY]

const BudgetStep = ({ formik, handleStepChange, remainingBudget }) => {
  const stepFormClasses = useStepFormStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values } = formik

  const { currency_symbol: currencySymbol } = useSelector(selectedTikTokAdAccountSelector)

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{t('What budget would you like to set for new ad group?')}</div>
      <div className={stepFormClasses.stepBody}>
        <section className={drawerFormClasses.section}>
          <div className={drawerFormClasses.sectionTitle}>{t('Budget')}</div>
          {/* Budget type selection is temporarily commented out, because for now we need only lifetime budget*/}
          {/*todo uncomment when needed*/}
          {/*<BudgetTypeField formik={formik} />*/}
          {values[BUDGET_OPTION] === BUDGET_LIFETIME ? (
            <>
              <p>{t('A total budget for the entire run-time of the ad group.')}</p>
              <p>{t('The budget will be spent evenly over its lifetime.')}</p>
              <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2 }))}</p>
              <Field
                type="number"
                formik={formik}
                name={BUDGET_LIFETIME}
                placeholder={t('Lifetime Budget')}
                symbol={currencySymbol}
                autoComplete="off"
                inputMode="numeric"
              />
            </>
          ) : (
            <>
              <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2 }))}</p>
              <Field
                type="number"
                formik={formik}
                name={BUDGET_DAILY}
                placeholder={t('Daily Budget')}
                symbol={currencySymbol}
                autoComplete="off"
                inputMode="numeric"
              />
            </>
          )}
        </section>
      </div>
      <div className={stepFormClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default BudgetStep
